"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1386],{

/***/ 49704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UnsupportedCurrencyFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9941);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65528);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20253);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99150);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39475);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41914);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74314);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64011);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38328);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53854);
/* harmony import */ var _hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 0;\n  width: 100%;\n  max-width: 400px;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  color: ",
        ";\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var DetailsFooter = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-85a76e0f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
});
var UnsupportedModal = function(param) {
    var currencies = param.currencies, onDismiss = param.onDismiss;
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().chainId;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var tokens = chainId && currencies ? currencies.map(function(currency) {
        return (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__/* .wrappedCurrency */ .pu)(currency, chainId);
    }) : [];
    var unsupportedTokens = (0,_hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__/* .useUnsupportedTokens */ .l6)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        title: t("Unsupported Assets"),
        maxWidth: "420px",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
            gap: "lg",
            children: [
                tokens.map(function(token) {
                    var ref;
                    return token && unsupportedTokens && Object.keys(unsupportedTokens).includes(token.address) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__/* .AutoRow */ .BA, {
                                gap: "5px",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_5__/* .CurrencyLogo */ .Xw, {
                                        currency: token,
                                        size: "24px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        children: token.symbol
                                    })
                                ]
                            }),
                            chainId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                external: true,
                                small: true,
                                color: "primaryDark",
                                href: (0,utils__WEBPACK_IMPORTED_MODULE_7__/* .getBscScanLink */ .s6)(token.address, "address", chainId),
                                children: token.address
                            })
                        ]
                    }, (ref = token.address) === null || ref === void 0 ? void 0 : ref.concat("not-supported"));
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                    gap: "lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: t("Some assets are not available through this interface because they may not work well with our smart contract or we are unable to allow trading for legal reasons.")
                    })
                })
            ]
        })
    });
};
function UnsupportedCurrencyFooter(param) {
    var currencies = param.currencies;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UnsupportedModal, {
        currencies: currencies
    })), 1), onPresentModal = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DetailsFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            variant: "text",
            onClick: onPresentModal,
            children: t("Read more about unsupported assets")
        })
    });
}


/***/ }),

/***/ 3620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTransactionDeadline; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
;// CONCATENATED MODULE: ./src/hooks/useCurrentBlockTimestamp.ts


// gets the current timestamp from the blockchain
function useCurrentBlockTimestamp() {
    var ref, ref1;
    var multicall = (0,useContract/* useMulticallContract */.gq)();
    return (ref = (0,hooks/* useSingleCallResult */.Wk)(multicall, "getCurrentBlockTimestamp")) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
}

;// CONCATENATED MODULE: ./src/hooks/useTransactionDeadline.ts



// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function useTransactionDeadline() {
    var ttl = (0,es/* useSelector */.v9)(function(state) {
        return state.user.userDeadline;
    });
    var blockTimestamp = useCurrentBlockTimestamp();
    return (0,react.useMemo)(function() {
        if (blockTimestamp && ttl) return blockTimestamp.add(ttl);
        return undefined;
    }, [
        blockTimestamp,
        ttl
    ]);
}


/***/ }),

/***/ 11386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Swap; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(48732);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@moonbiz/sdk/dist/sdk.esm.js + 58 modules
var sdk_esm = __webpack_require__(64922);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useMatchBreakpoints.ts + 1 modules
var useMatchBreakpoints = __webpack_require__(70589);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/BottomDrawer/BottomDrawer.tsx + 2 modules
var BottomDrawer = __webpack_require__(72836);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(6372);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUpDown.tsx
var ArrowUpDown = __webpack_require__(92863);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(23715);
// EXTERNAL MODULE: ./src/components/UnsupportedCurrencyFooter.tsx
var UnsupportedCurrencyFooter = __webpack_require__(49704);
// EXTERNAL MODULE: ./src/components/Menu/Footer.tsx
var Footer = __webpack_require__(13625);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(3862);
// EXTERNAL MODULE: ./src/utils/maxAmountSpend.ts
var maxAmountSpend = __webpack_require__(45131);
// EXTERNAL MODULE: ./src/utils/prices.ts
var prices = __webpack_require__(7879);
// EXTERNAL MODULE: ./src/config/constants/tokens.ts
var tokens = __webpack_require__(29748);
;// CONCATENATED MODULE: ./src/config/constants/swapWarningTokens.ts

var bondly = tokens/* default.bondly */.ZP.bondly, safemoon = tokens/* default.safemoon */.ZP.safemoon, itam = tokens/* default.itam */.ZP.itam, ccar = tokens/* default.ccar */.ZP.ccar, bttold = tokens/* default.bttold */.ZP.bttold;
var SwapWarningTokens = {
    safemoon: safemoon,
    bondly: bondly,
    itam: itam,
    ccar: ccar,
    bttold: bttold
};
/* harmony default export */ var swapWarningTokens = (SwapWarningTokens);

;// CONCATENATED MODULE: ./src/utils/shouldShowSwapWarning.ts

var shouldShowSwapWarning_swapWarningTokens = Object.values(swapWarningTokens);
var shouldShowSwapWarning = function(swapCurrency) {
    return shouldShowSwapWarning_swapWarningTokens.some(function(warningToken) {
        return swapCurrency.address === warningToken.address;
    });
};
/* harmony default export */ var utils_shouldShowSwapWarning = (shouldShowSwapWarning);

// EXTERNAL MODULE: ./src/state/satt/hooks.ts
var hooks = __webpack_require__(12049);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/views/Swap/hooks/useRefreshBlockNumber.ts


var useRefreshBlockNumber = function() {
    var ref = (0,react.useState)(false), isLoading = ref[0], setFetch = ref[1];
    var refreshBlockNumber = (0,react.useCallback)(function() {
        if (!isLoading) {
            setFetch(true);
        }
    }, [
        isLoading
    ]);
    var mutate = (0,dist/* useSWRConfig */.kY)().mutate;
    (0,react.useEffect)(function() {
        if (!isLoading) return;
        mutate("blockNumber");
        // setTimeout is used to demonstrate the loading
        // because the real loading state occurs on multicall state
        // we don't know when the fetch is finished.
        setTimeout(function() {
            return setFetch(false);
        }, 500);
    }, [
        mutate,
        isLoading
    ]);
    return {
        refreshBlockNumber: refreshBlockNumber,
        isLoading: isLoading
    };
};
/* harmony default export */ var hooks_useRefreshBlockNumber = (useRefreshBlockNumber);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var utils = __webpack_require__(38328);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(41914);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(39475);
;// CONCATENATED MODULE: ./src/views/Swap/components/AddressInputPanel.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  border-radius: 1.25rem;\n  background-color: ",
        ";\n  z-index: 1;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 1.25rem;\n  border: 1px solid ",
        ";\n  transition: border-color 300ms ",
        ",\n    color 500ms ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  padding: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: ",
        ";\n  transition: color 300ms ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n  width: 100%;\n  ::placeholder {\n    color: ",
        ";\n  }\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ae8a5e6-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var ContainerRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ae8a5e6-1"
})(_templateObject1(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.background;
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var InputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ae8a5e6-2"
})(_templateObject2());
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-3ae8a5e6-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
function AddressInputPanel(param) {
    var id = param.id, value = param.value, onChange = param.onChange;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var address = (0,utils/* isAddress */.UJ)(value) ? value : undefined;
    var handleInput = (0,react.useCallback)(function(event) {
        var input = event.target.value;
        var withoutSpaces = input.replace(/\s+/g, "");
        onChange(withoutSpaces);
    }, [
        onChange
    ]);
    var error = Boolean(value.length > 0 && !address);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPanel, {
        id: id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerRow, {
            error: error,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: t("Recipient")
                                }),
                                address && chainId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                    external: true,
                                    small: true,
                                    href: (0,utils/* getBscScanLink */.s6)(address, "address", chainId),
                                    children: [
                                        "(",
                                        t("View on BscScan"),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            className: "recipient-address-input",
                            type: "text",
                            autoComplete: "off",
                            autoCorrect: "off",
                            autoCapitalize: "off",
                            spellCheck: "false",
                            placeholder: t("Wallet Address"),
                            error: error,
                            pattern: "^(0x[a-fA-F0-9]{40})$",
                            onChange: handleInput,
                            value: value
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(36261);
// EXTERNAL MODULE: ./src/components/TransactionConfirmationModal/index.tsx + 1 modules
var TransactionConfirmationModal = __webpack_require__(40874);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(45061);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Error.tsx
var Icons_Error = __webpack_require__(44700);
;// CONCATENATED MODULE: ./src/views/Swap/components/styleds.tsx

function styleds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 1rem;\n"
    ]);
    styleds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styleds_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          :hover {\n            cursor: pointer;\n            opacity: 0.8;\n          }\n        "
    ]);
    styleds_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styleds_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px;\n\n  ",
        "\n"
    ]);
    styleds_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styleds_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    styleds_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 22px;\n  width: 22px;\n  background-color: ",
        ";\n  border: none;\n  border-radius: 50%;\n  padding: 0.2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  margin-left: 0.4rem;\n  cursor: pointer;\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n\n  :hover {\n    background-color: ",
        ";\n  }\n  :focus {\n    background-color: ",
        ";\n    outline: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 220px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 0.825rem;\n  width: 100%;\n  padding: 3rem 1.25rem 1rem 1rem;\n  margin-top: -2rem;\n  color: ",
        ";\n  z-index: -1;\n  p {\n    padding: 0;\n    margin: 0;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  border-radius: 12px;\n  min-width: 48px;\n  height: 48px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0.5rem;\n  border-radius: 12px;\n  margin-top: 8px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4d6dcedb-0"
})(styleds_templateObject());
var ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d6dcedb-1"
})(styleds_templateObject2(), function(param) {
    var clickable = param.clickable;
    return clickable ? (0,styled_components_browser_esm/* css */.iv)(styleds_templateObject1()) : null;
});
var ErrorText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4d6dcedb-2"
})(styleds_templateObject3(), function(param) {
    var theme = param.theme, severity = param.severity;
    return severity === 3 || severity === 4 ? theme.colors.failure : severity === 2 ? theme.colors.warning : severity === 1 ? theme.colors.text : theme.colors.success;
});
var StyledBalanceMaxMini = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4d6dcedb-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});
var TruncatedText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    ellipsis: true
}).withConfig({
    componentId: "sc-4d6dcedb-4"
})(_templateObject5());
var SwapCallbackErrorInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d6dcedb-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure, "33");
}, function(param) {
    var theme = param.theme;
    return theme.colors.failure;
});
var SwapCallbackErrorInnerAlertTriangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d6dcedb-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure, "33");
});
function SwapCallbackError(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapCallbackErrorInner, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackErrorInnerAlertTriangle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                    width: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: error
            })
        ]
    });
}
var SwapShowAcceptChanges = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-4d6dcedb-7"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.warning, "33");
});

;// CONCATENATED MODULE: ./src/views/Swap/components/FormattedPriceImpact.tsx




/**
 * Formatted version of price impact text with warning colors
 */ function FormattedPriceImpact(param) {
    var priceImpact = param.priceImpact;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
        fontSize: "14px",
        severity: (0,prices/* warningSeverity */.oX)(priceImpact),
        children: priceImpact ? priceImpact.lessThan(constants/* ONE_BIPS */.IS) ? "<0.01%" : "".concat(priceImpact.toFixed(2), "%") : "-"
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapModalFooter.tsx

function SwapModalFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  padding: 16px;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    SwapModalFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







// import { useSattWallet } from 'state/satt/hooks'






var SwapModalFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-6008b6a8-0"
})(SwapModalFooter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.radii.default;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
function SwapModalFooter(param) {
    var trade = param.trade, onConfirm = param.onConfirm, allowedSlippage = param.allowedSlippage, swapErrorMessage = param.swapErrorMessage, disabledConfirm = param.disabledConfirm;
    var ref, ref1;
    var t = (0,Localization/* useTranslation */.$G)().t;
    // const { isSattConnected } = useSattWallet()
    var ref2 = (0,react.useState)(false), showInverted = ref2[0], setShowInverted = ref2[1];
    var slippageAdjustedAmounts = (0,react.useMemo)(function() {
        return (0,prices/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage);
    }, [
        allowedSlippage,
        trade
    ]);
    var ref3 = (0,react.useMemo)(function() {
        return (0,prices/* computeTradePriceBreakdown */.U7)(trade);
    }, [
        trade
    ]), priceImpactWithoutFee = ref3.priceImpactWithoutFee, realizedLPFee = ref3.realizedLPFee;
    var severity = (0,prices/* warningSeverity */.oX)(priceImpactWithoutFee);
    var onConfirmSwap = function() {
        // if (isSattConnected) {
        //   return onPresentSattPasswordModal()
        // }
        return onConfirm();
    };
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapModalFooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "14px",
                                style: {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    textAlign: "right",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    (0,prices/* formatExecutionPrice */.Kh)(trade, showInverted),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                                        onClick: function() {
                                            return setShowInverted(!showInverted);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Minimum received") : t("Maximum sold")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref4 = (ref = slippageAdjustedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4)) !== null && ref4 !== void 0 ? ref4 : "-" : (ref5 = (ref1 = slippageAdjustedAmounts[actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4)) !== null && ref5 !== void 0 ? ref5 : "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        marginLeft: "4px",
                                        children: trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: t("Price Impact")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: t("The difference between the market price and your price due to trade size."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedPriceImpact, {
                                priceImpact: priceImpactWithoutFee
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: t("Liquidity Provider Fee")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mb: "12px",
                                                    children: t("For each trade a %amount% fee is paid", {
                                                        amount: "0.25%"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        "- ",
                                                        t("%amount% to LP token holders", {
                                                            amount: "0.17%"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        "- ",
                                                        t("%amount% to the Treasury", {
                                                            amount: "0.03%"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        "- ",
                                                        t("%amount% towards CAKE buyback and burn", {
                                                            amount: "0.05%"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: realizedLPFee ? "".concat(realizedLPFee === null || realizedLPFee === void 0 ? void 0 : realizedLPFee.toSignificant(6), " ").concat(trade.inputAmount.currency.symbol) : "-"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: severity > 2 ? "danger" : "primary",
                        onClick: onConfirmSwap,
                        disabled: disabledConfirm,
                        mt: "12px",
                        id: "confirm-swap-or-send",
                        width: "100%",
                        children: severity > 2 ? t("Swap Anyway") : t("Confirm Swap")
                    }),
                    swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                        error: swapErrorMessage
                    }) : null
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(74314);
// EXTERNAL MODULE: ./src/utils/truncateHash.ts
var truncateHash = __webpack_require__(53467);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapModalHeader.tsx













function SwapModalHeader(param) {
    var trade = param.trade, allowedSlippage = param.allowedSlippage, recipient = param.recipient, showAcceptChanges = param.showAcceptChanges, onAcceptChanges = param.onAcceptChanges;
    var ref, ref1;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var slippageAdjustedAmounts = (0,react.useMemo)(function() {
        return (0,prices/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage);
    }, [
        trade,
        allowedSlippage
    ]);
    var priceImpactWithoutFee = (0,react.useMemo)(function() {
        return (0,prices/* computeTradePriceBreakdown */.U7)(trade);
    }, [
        trade
    ]).priceImpactWithoutFee;
    var priceImpactSeverity = (0,prices/* warningSeverity */.oX)(priceImpactWithoutFee);
    var amount = trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref = slippageAdjustedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(6) : (ref1 = slippageAdjustedAmounts[actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6);
    var symbol = trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol;
    var tradeInfoText = trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Output is estimated. You will receive at least %amount% %symbol% or the transaction will revert.", {
        amount: amount,
        symbol: symbol
    }) : t("Input is estimated. You will sell at most %amount% %symbol% or the transaction will revert.", {
        amount: amount,
        symbol: symbol
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)(tradeInfoText.split("".concat(amount, " ").concat(symbol)), 2), estimatedText = ref2[0], transactionRevertText = ref2[1];
    var truncatedRecipient = recipient ? (0,truncateHash/* default */.Z)(recipient) : "";
    var recipientInfoText = t("Output will be sent to %recipient%", {
        recipient: truncatedRecipient
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(recipientInfoText.split(truncatedRecipient), 2), recipientSentToText = ref3[0], postSentToText = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        gap: "0px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: trade.inputAmount.currency,
                                size: "24px",
                                style: {
                                    marginRight: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: showAcceptChanges && trade.tradeType === sdk_esm/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? "primary" : "text",
                                children: trade.inputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        gap: "0px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.inputAmount.currency.symbol
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: "16px",
                    ml: "4px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        gap: "0px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: trade.outputAmount.currency,
                                size: "24px",
                                style: {
                                    marginRight: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: priceImpactSeverity > 2 ? "failure" : showAcceptChanges && trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "primary" : "text",
                                children: trade.outputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        gap: "0px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.outputAmount.currency.symbol
                        })
                    })
                ]
            }),
            showAcceptChanges ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapShowAcceptChanges, {
                justify: "flex-start",
                gap: "0px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                                    mr: "8px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    children: [
                                        " ",
                                        t("Price Updated")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onAcceptChanges,
                            children: t("Accept")
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "24px 0 0 0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    small: true,
                    color: "textSubtle",
                    textAlign: "left",
                    style: {
                        width: "100%"
                    },
                    children: [
                        estimatedText,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                amount,
                                " ",
                                symbol
                            ]
                        }),
                        transactionRevertText
                    ]
                })
            }),
            recipient !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "12px 0 0 0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: [
                        recipientSentToText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            title: recipient,
                            children: truncatedRecipient
                        }),
                        postSentToText
                    ]
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/ConfirmSwapModal.tsx







// import SattPasswordModal from './SattPasswordModal'
/**
 * Returns true if the trade requires a confirmation of details before we can submit it
 * @param tradeA trade A
 * @param tradeB trade B
 */ function tradeMeaningfullyDiffers(tradeA, tradeB) {
    return tradeA.tradeType !== tradeB.tradeType || !(0,sdk_esm/* currencyEquals */.KA)(tradeA.inputAmount.currency, tradeB.inputAmount.currency) || !tradeA.inputAmount.equalTo(tradeB.inputAmount) || !(0,sdk_esm/* currencyEquals */.KA)(tradeA.outputAmount.currency, tradeB.outputAmount.currency) || !tradeA.outputAmount.equalTo(tradeB.outputAmount);
}
var ConfirmSwapModal = function(param) {
    var trade = param.trade, originalTrade = param.originalTrade, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage, onConfirm = param.onConfirm, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, recipient = param.recipient, swapErrorMessage = param.swapErrorMessage, attemptingTxn = param.attemptingTxn, txHash = param.txHash;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var showAcceptChanges = (0,react.useMemo)(function() {
        return Boolean(trade && originalTrade && tradeMeaningfullyDiffers(trade, originalTrade));
    }, [
        originalTrade,
        trade
    ]);
    var t = (0,Localization/* useTranslation */.$G)().t;
    var modalHeader = (0,react.useCallback)(function() {
        return trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapModalHeader, {
            trade: trade,
            allowedSlippage: allowedSlippage,
            recipient: recipient,
            showAcceptChanges: showAcceptChanges,
            onAcceptChanges: onAcceptChanges
        }) : null;
    }, [
        allowedSlippage,
        onAcceptChanges,
        recipient,
        showAcceptChanges,
        trade
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        return trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapModalFooter, {
            onConfirm: onConfirm,
            trade: trade,
            disabledConfirm: showAcceptChanges,
            swapErrorMessage: swapErrorMessage,
            allowedSlippage: allowedSlippage
        }) : null;
    }, [
        allowedSlippage,
        onConfirm,
        showAcceptChanges,
        swapErrorMessage,
        trade
    ]);
    var ref6, ref7, ref8, ref9;
    // text to show while loading
    var pendingText = t("Swapping %amountA% %symbolA% for %amountB% %symbolB%", {
        amountA: (ref6 = trade === null || trade === void 0 ? void 0 : (ref = trade.inputAmount) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref6 !== void 0 ? ref6 : "",
        symbolA: (ref7 = trade === null || trade === void 0 ? void 0 : (ref1 = trade.inputAmount) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.currency) === null || ref2 === void 0 ? void 0 : ref2.symbol) !== null && ref7 !== void 0 ? ref7 : "",
        amountB: (ref8 = trade === null || trade === void 0 ? void 0 : (ref3 = trade.outputAmount) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "",
        symbolB: (ref9 = trade === null || trade === void 0 ? void 0 : (ref4 = trade.outputAmount) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.currency) === null || ref5 === void 0 ? void 0 : ref5.symbol) !== null && ref9 !== void 0 ? ref9 : ""
    });
    var confirmationContent = (0,react.useCallback)(function() {
        return swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
            onDismiss: onDismiss,
            message: swapErrorMessage
        }) : // ) : ShowSattPasswordModal ? (
        //   <SattPasswordModal confirmSattTransaction={onConfirm} ShowSattPasswordModal={ShowSattPasswordModal} />
        // ) :
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        onDismiss,
        modalBottom,
        modalHeader,
        swapErrorMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* default */.ZP, {
        title: t("Confirm Swap"),
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        content: confirmationContent,
        pendingText: pendingText,
        currencyToAdd: trade === null || trade === void 0 ? void 0 : trade.outputAmount.currency
    });
};
/* harmony default export */ var components_ConfirmSwapModal = (ConfirmSwapModal);

// EXTERNAL MODULE: ./src/views/Swap/components/SattPasswordModal.tsx
var SattPasswordModal = __webpack_require__(95704);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/index.tsx + 1 modules
var CurrencyInputPanel = __webpack_require__(19527);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
;// CONCATENATED MODULE: ./src/hooks/useLast.ts

/**
 * Returns the last value of type T that passes a filter function
 * @param value changing value
 * @param filterFn function that determines whether a given value should be considered for the last value
 */ function useLast(value, filterFn) {
    var ref = (0,react.useState)(filterFn && filterFn(value) ? value : undefined), last = ref[0], setLast = ref[1];
    (0,react.useEffect)(function() {
        setLast(function(prev) {
            var shouldUse = filterFn ? filterFn(value) : true;
            if (shouldUse) return value;
            return prev;
        });
    }, [
        filterFn,
        value
    ]);
    return last;
}
function isDefined(x) {
    return x !== null && x !== undefined;
}
/**
 * Returns the last truthy value of type T
 * @param value changing value
 */ function useLastTruthy(value) {
    return useLast(value, isDefined);
}
/* harmony default export */ var hooks_useLast = (useLastTruthy);

// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(94528);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(53854);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapRoute.tsx




/* harmony default export */ var SwapRoute = (/*#__PURE__*/(0,react.memo)(function SwapRoute(param) {
    var trade = param.trade;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexWrap: "wrap",
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
        children: trade.route.path.map(function(token, i, path) {
            var isLastItem = i === path.length - 1;
            var currency = (0,wrappedCurrency/* unwrappedToken */.Bv)(token);
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            ml: "0.125rem",
                            mr: "0.125rem",
                            children: currency.symbol
                        })
                    }),
                    !isLastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                        width: "12px"
                    })
                ]
            }, i));
        })
    });
}));

;// CONCATENATED MODULE: ./src/views/Swap/components/AdvancedSwapDetails.tsx













function TradeSummary(param) {
    var trade = param.trade, allowedSlippage = param.allowedSlippage;
    var ref, ref1;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref2 = (0,prices/* computeTradePriceBreakdown */.U7)(trade), priceImpactWithoutFee = ref2.priceImpactWithoutFee, realizedLPFee = ref2.realizedLPFee;
    var isExactIn = trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT;
    var slippageAdjustedAmounts = (0,prices/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage);
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        style: {
            padding: "0 16px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: isExactIn ? t("Minimum received") : t("Maximum sold")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                ml: "4px",
                                placement: "top-start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            children: isExactIn ? (ref3 = "".concat((ref = slippageAdjustedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4), " ").concat(trade.outputAmount.currency.symbol)) !== null && ref3 !== void 0 ? ref3 : "-" : (ref4 = "".concat((ref1 = slippageAdjustedAmounts[actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4), " ").concat(trade.inputAmount.currency.symbol)) !== null && ref4 !== void 0 ? ref4 : "-"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: t("Price Impact")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("The difference between the market price and estimated price due to trade size."),
                                ml: "4px",
                                placement: "top-start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedPriceImpact, {
                        priceImpact: priceImpactWithoutFee
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: t("Liquidity Provider Fee")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mb: "12px",
                                            children: t("For each trade a %amount% fee is paid", {
                                                amount: "0.25%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            children: [
                                                "- ",
                                                t("%amount% to LP token holders", {
                                                    amount: "0.17%"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            children: [
                                                "- ",
                                                t("%amount% to the Treasury", {
                                                    amount: "0.03%"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            children: [
                                                "- ",
                                                t("%amount% towards CAKE buyback and burn", {
                                                    amount: "0.05%"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                ml: "4px",
                                placement: "top-start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        children: realizedLPFee ? "".concat(realizedLPFee.toSignificant(4), " ").concat(trade.inputAmount.currency.symbol) : "-"
                    })
                ]
            })
        ]
    });
}
function AdvancedSwapDetails(param) {
    var trade = param.trade;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref[0];
    var showRoute = Boolean(trade && trade.route.path.length > 2);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
        gap: "0px",
        children: trade && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeSummary, {
                    trade: trade,
                    allowedSlippage: allowedSlippage
                }),
                showRoute && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        style: {
                            padding: "0 16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("Route")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: t("Routing through these tokens resulted in the best price for your trade."),
                                        ml: "4px",
                                        placement: "top-start"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapRoute, {
                                trade: trade
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/AdvancedSwapDetailsDropdown.tsx




function AdvancedSwapDetailsDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  padding-top: 16px;\n  padding-bottom: 16px;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 20px;\n  background-color: ",
        ";\n\n  transform: ",
        ";\n  transition: transform 300ms ease-in-out;\n"
    ]);
    AdvancedSwapDetailsDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var AdvancedDetailsFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddb625d1-0"
})(AdvancedSwapDetailsDropdown_templateObject(), function(param) {
    var show = param.show;
    return show ? "16px" : 0;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var show = param.show;
    return show ? "translateY(0%)" : "translateY(-100%)";
});
function AdvancedSwapDetailsDropdown(_param) {
    var trade = _param.trade, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "trade"
    ]);
    var lastTrade = hooks_useLast(trade);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedDetailsFooter, {
        show: Boolean(trade),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSwapDetails, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            trade: (ref = trade !== null && trade !== void 0 ? trade : lastTrade) !== null && ref !== void 0 ? ref : undefined
        }))
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/confirmPriceImpactWithoutFee.ts

/**
 * Given the price impact, get user confirmation.
 *
 * @param priceImpactWithoutFee price impact of the trade without the fee.
 * @param t Translation
 */ function confirmPriceImpactWithoutFee(priceImpactWithoutFee, t) {
    if (!priceImpactWithoutFee.lessThan(constants/* PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN */.EV)) {
        var confirmWord = "confirm";
        return(// eslint-disable-next-line no-alert
        window.prompt(t('This swap has a price impact of at least %amount%%. Please type the word "%word%" to continue with this swap.', {
            amount: constants/* PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN.toFixed */.EV.toFixed(0),
            word: confirmWord
        })) === confirmWord);
    }
    if (!priceImpactWithoutFee.lessThan(constants/* ALLOWED_PRICE_IMPACT_HIGH */.Uf)) {
        // eslint-disable-next-line no-alert
        return window.confirm(t("This swap has a price impact of at least %amount%%. Please confirm that you would like to continue with this swap.", {
            amount: constants/* ALLOWED_PRICE_IMPACT_HIGH.toFixed */.Uf.toFixed(0)
        }));
    }
    return true;
}

;// CONCATENATED MODULE: ./src/views/Swap/components/TradePrice.tsx



function TradePrice(param) {
    var price = param.price, showInverted = param.showInverted, setShowInverted = param.setShowInverted;
    var ref, ref1, ref2, ref3, ref4;
    var formattedPrice = showInverted ? price === null || price === void 0 ? void 0 : price.toSignificant(6) : (ref = price === null || price === void 0 ? void 0 : price.invert()) === null || ref === void 0 ? void 0 : ref.toSignificant(6);
    var show = Boolean((price === null || price === void 0 ? void 0 : price.baseCurrency) && (price === null || price === void 0 ? void 0 : price.quoteCurrency));
    var label = showInverted ? "".concat(price === null || price === void 0 ? void 0 : (ref1 = price.quoteCurrency) === null || ref1 === void 0 ? void 0 : ref1.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref2 = price.baseCurrency) === null || ref2 === void 0 ? void 0 : ref2.symbol) : "".concat(price === null || price === void 0 ? void 0 : (ref3 = price.baseCurrency) === null || ref3 === void 0 ? void 0 : ref3.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref4 = price.quoteCurrency) === null || ref4 === void 0 ? void 0 : ref4.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: {
            justifyContent: "center",
            alignItems: "center",
            display: "flex"
        },
        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : "-",
                " ",
                label,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                    onClick: function() {
                        return setShowInverted(!showInverted);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        width: "14px"
                    })
                })
            ]
        }) : "-"
    });
}

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./src/components/SearchModal/ImportToken.tsx
var ImportToken = __webpack_require__(9189);
;// CONCATENATED MODULE: ./src/views/Swap/components/ImportTokenWarningModal.tsx




var ImportTokenWarningModal = function(param) {
    var tokens = param.tokens, onDismiss = param.onDismiss, onCancel = param.onCancel;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: t("Import Token"),
        onDismiss: function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            onCancel();
        },
        style: {
            maxWidth: "420px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportToken/* default */.Z, {
            tokens: tokens,
            handleCurrencySelect: onDismiss
        })
    });
};
/* harmony default export */ var components_ImportTokenWarningModal = (ImportTokenWarningModal);

;// CONCATENATED MODULE: ./src/views/Swap/components/ProgressSteps.tsx




function ProgressSteps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n"
    ]);
    ProgressSteps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProgressSteps_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 20px;\n  min-height: 20px;\n  background-color: ",
        ";\n  border-radius: 50%;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 8px;\n  font-size: 12px;\n"
    ]);
    ProgressSteps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProgressSteps_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 20px);\n  display: flex;\n  align-items: center;\n"
    ]);
    ProgressSteps_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProgressSteps_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(\n    90deg,\n    ",
        "\n      0%,\n    ",
        "\n      80%\n  );\n  opacity: 0.6;\n"
    ]);
    ProgressSteps_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Grouping = (0,styled_components_browser_esm/* default */.ZP)(Row/* RowBetween */.m0).withConfig({
    componentId: "sc-b6a41b3e-0"
})(ProgressSteps_templateObject());
var Circle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6a41b3e-1"
})(ProgressSteps_templateObject1(), function(param) {
    var theme = param.theme, confirmed = param.confirmed, disabled = param.disabled;
    return disabled ? theme.colors.backgroundDisabled : confirmed ? theme.colors.success : theme.colors.primary;
});
var CircleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6a41b3e-2"
})(ProgressSteps_templateObject2());
var Connector = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6a41b3e-3"
})(ProgressSteps_templateObject3(), function(param) {
    var theme = param.theme, prevConfirmed = param.prevConfirmed, disabled = param.disabled;
    return disabled ? theme.colors.backgroundDisabled : prevConfirmed ? theme.colors.success : theme.colors.primary;
}, function(param) {
    var theme = param.theme, prevConfirmed = param.prevConfirmed, disabled = param.disabled;
    return disabled ? theme.colors.backgroundDisabled : prevConfirmed ? theme.colors.primary : theme.colors.backgroundDisabled;
});
/**
 * Based on array of steps, create a step counter of circles.
 * A circle can be enabled, disabled, or confirmed. States are derived
 * from previous step.
 *
 * An extra circle is added to represent the ability to swap, add, or remove.
 * This step will never be marked as complete (because no 'txn done' state in body ui).
 *
 * @param steps  array of booleans where true means step is complete
 */ function ProgressCircles(_param) {
    var steps = _param.steps, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "steps",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        justify: "center"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grouping, {
            children: [
                steps.map(function(step, i) {
                    return(// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircleRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                                confirmed: step,
                                disabled: disabled || !steps[i - 1] && i !== 0,
                                children: step ? "✓" : i + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Connector, {
                                prevConfirmed: step,
                                disabled: disabled
                            })
                        ]
                    }, i));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                    disabled: disabled || !steps[steps.length - 1],
                    children: steps.length + 1
                })
            ]
        })
    }));
}

// EXTERNAL MODULE: ./src/components/App/index.tsx + 3 modules
var App = __webpack_require__(45460);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(86435);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts + 1 modules
var useApproveCallback = __webpack_require__(50165);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
;// CONCATENATED MODULE: ./src/utils/isZero.ts
/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */ function isZero(hexNumberString) {
    return /^0x0*$/.test(hexNumberString);
}

// EXTERNAL MODULE: ./src/hooks/useTransactionDeadline.ts + 1 modules
var useTransactionDeadline = __webpack_require__(3620);
;// CONCATENATED MODULE: ./src/hooks/useSwapCallArguments.ts







/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName
 */ function useSwapCallArguments(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0, factoryType = arguments.length > 3 ? arguments[3] : void 0;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId, library = ref.library;
    var sattAddress = (0,hooks/* useSattWallet */.M)().sattAddress;
    var address = account || sattAddress || undefined;
    var recipient = recipientAddress === null ? address : recipientAddress;
    var deadline = (0,useTransactionDeadline/* default */.Z)();
    return (0,react.useMemo)(function() {
        if (!trade || !recipient || !library || !address || !chainId || !deadline) return [];
        var contract = factoryType === "MoonBiz" ? (0,utils/* getRouterContract */.iY)(chainId, library, account) : (0,utils/* getRouterContractPancake */.u_)(chainId, library, account);
        if (!contract) {
            return [];
        }
        var swapMethods = [];
        swapMethods.push(sdk_esm/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
            feeOnTransfer: false,
            allowedSlippage: new sdk_esm/* Percent */.gG(sdk_esm/* JSBI.BigInt */.QA.BigInt(allowedSlippage), constants/* BIPS_BASE */.PM),
            recipient: recipient,
            deadline: deadline.toNumber()
        }));
        if (trade.tradeType === sdk_esm/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT) {
            swapMethods.push(sdk_esm/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
                feeOnTransfer: true,
                allowedSlippage: new sdk_esm/* Percent */.gG(sdk_esm/* JSBI.BigInt */.QA.BigInt(allowedSlippage), constants/* BIPS_BASE */.PM),
                recipient: recipient,
                deadline: deadline.toNumber()
            }));
        }
        return swapMethods.map(function(parameters) {
            return {
                parameters: parameters,
                contract: contract
            };
        });
    }, [
        account,
        address,
        allowedSlippage,
        chainId,
        deadline,
        library,
        recipient,
        trade,
        factoryType
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useSwapCallback.ts







// import { useSattWallet } from 'state/satt/hooks'


// import { useSwapCallForSatt } from './useSwapCallForSatt'





var SwapCallbackState;
(function(SwapCallbackState) {
    SwapCallbackState[SwapCallbackState["INVALID"] = 0] = "INVALID";
    SwapCallbackState[SwapCallbackState["LOADING"] = 1] = "LOADING";
    SwapCallbackState[SwapCallbackState["VALID"] = 2] = "VALID";
})(SwapCallbackState || (SwapCallbackState = {}));
// returns a function that will execute a swap, if the parameters are all valid
// and the user has approved the slippage adjusted input amount for the trade
function useSwapCallback(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0, factoryType = arguments.length > 3 ? arguments[3] : void 0;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId, library = ref.library;
    // const { sattAddress, sattPassword } = useSattWallet()
    // const { getSwapCallForSatt } = useSwapCallForSatt(trade, allowedSlippage, recipientAddress)
    // const address = account || sattAddress|| undefined
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var swapCalls = useSwapCallArguments(trade, allowedSlippage, recipientAddress, factoryType);
    var t = (0,Localization/* useTranslation */.$G)().t;
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var recipient = recipientAddress === null ? account : recipientAddress;
    return (0,react.useMemo)(function() {
        if (!trade || !library || !account || !chainId) {
            return {
                state: SwapCallbackState.INVALID,
                callback: null,
                error: "Missing dependencies"
            };
        }
        if (!recipient) {
            if (recipientAddress !== null) {
                return {
                    state: SwapCallbackState.INVALID,
                    callback: null,
                    error: "Invalid recipient"
                };
            }
            return {
                state: SwapCallbackState.LOADING,
                callback: null,
                error: null
            };
        }
        return {
            state: SwapCallbackState.VALID,
            callback: function() {
                var _onSwap = (0,_async_to_generator/* default */.Z)(function() {
                    var _contract, estimatedCalls, successfulEstimation, errorCalls, _call, contract, _parameters, methodName, args, value, gasEstimate;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(swapCalls.map(function(call) {
                                        var _estimateGas;
                                        var _parameters = call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, contract = call.contract;
                                        var options = !value || isZero(value) ? {} : {
                                            value: value
                                        };
                                        return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(args).concat([
                                            options
                                        ])).then(function(gasEstimate) {
                                            return {
                                                call: call,
                                                gasEstimate: gasEstimate
                                            };
                                        }).catch(function(gasError) {
                                            var _callStatic;
                                            console.error("Gas estimate failed, trying eth_call to extract error", call);
                                            return (_callStatic = contract.callStatic)[methodName].apply(_callStatic, (0,_to_consumable_array/* default */.Z)(args).concat([
                                                options
                                            ])).then(function(result) {
                                                console.error("Unexpected successful call after failed estimate gas", call, gasError, result);
                                                return {
                                                    call: call,
                                                    error: t("Unexpected issue with estimating the gas. Please try again.")
                                                };
                                            }).catch(function(callError) {
                                                console.error("Call threw error", call, callError);
                                                return {
                                                    call: call,
                                                    error: swapErrorToUserReadableMessage(callError, t)
                                                };
                                            });
                                        });
                                    }))
                                ];
                            case 1:
                                estimatedCalls = _state.sent();
                                successfulEstimation = estimatedCalls.find(function(el, ix, list) {
                                    return "gasEstimate" in el && (ix === list.length - 1 || "gasEstimate" in list[ix + 1]);
                                });
                                if (!successfulEstimation) {
                                    errorCalls = estimatedCalls.filter(function(call) {
                                        return "error" in call;
                                    });
                                    if (errorCalls.length > 0) throw new Error(errorCalls[errorCalls.length - 1].error);
                                    throw new Error(t("Unexpected error. Could not estimate gas for the swap."));
                                }
                                _call = successfulEstimation.call, contract = _call.contract, _parameters = _call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, gasEstimate = successfulEstimation.gasEstimate;
                                return [
                                    2,
                                    (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(args).concat([
                                        (0,_object_spread/* default */.Z)({
                                            gasLimit: (0,utils/* calculateGasMargin */.yC)(gasEstimate),
                                            gasPrice: gasPrice
                                        }, value && !isZero(value) ? {
                                            value: value,
                                            from: account
                                        } : {
                                            from: account
                                        })
                                    ])).then(function(response) {
                                        var inputSymbol = trade.inputAmount.currency.symbol;
                                        var outputSymbol = trade.outputAmount.currency.symbol;
                                        var inputAmount = trade.inputAmount.toSignificant(3);
                                        var outputAmount = trade.outputAmount.toSignificant(3);
                                        var base = "Swap ".concat(inputAmount, " ").concat(inputSymbol, " for ").concat(outputAmount, " ").concat(outputSymbol);
                                        var withRecipient = recipient === account ? base : "".concat(base, " to ").concat(recipientAddress && (0,utils/* isAddress */.UJ)(recipientAddress) ? (0,truncateHash/* default */.Z)(recipientAddress) : recipientAddress);
                                        addTransaction(response, {
                                            summary: withRecipient
                                        });
                                        return response.hash;
                                    }).catch(function(error) {
                                        // if the user rejected the tx, pass this along
                                        if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                                            throw new Error("Transaction rejected.");
                                        } else {
                                            // otherwise, the error was unexpected and we need to convey that
                                            console.error("Swap failed", error, methodName, args, value);
                                        // throw new Error(t('Swap failed: %message%', { message: swapErrorToUserReadableMessage(error, t) }))
                                        }
                                    })
                                ];
                        }
                    });
                });
                function onSwap() {
                    return _onSwap.apply(this, arguments);
                }
                return onSwap;
            }(),
            error: null
        };
    }, [
        trade,
        library,
        account,
        chainId,
        recipient,
        recipientAddress,
        swapCalls,
        gasPrice,
        t,
        addTransaction
    ]);
}
/**
 * This is hacking out the revert reason from the ethers provider thrown error however it can.
 * This object seems to be undocumented by ethers.
 * @param error an error from the ethers provider
 */ function swapErrorToUserReadableMessage(error, t) {
    var reason;
    while(error){
        var ref, ref1;
        var _reason, ref2, ref3;
        reason = (ref3 = (ref2 = (_reason = error.reason) !== null && _reason !== void 0 ? _reason : (ref = error.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref2 !== void 0 ? ref2 : error.message) !== null && ref3 !== void 0 ? ref3 : reason;
        var _error;
        // eslint-disable-next-line no-param-reassign
        error = (_error = error.error) !== null && _error !== void 0 ? _error : (ref1 = error.data) === null || ref1 === void 0 ? void 0 : ref1.originalError;
    }
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("execution reverted: ")) === 0) reason = reason.substring("execution reverted: ".length);
    switch(reason){
        case "PancakeRouter: EXPIRED":
            return t("The transaction could not be sent because the deadline has passed. Please check that your transaction deadline is not too low.");
        case "PancakeRouter: INSUFFICIENT_OUTPUT_AMOUNT":
        case "PancakeRouter: EXCESSIVE_INPUT_AMOUNT":
            return t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.");
        case "TransferHelper: TRANSFER_FROM_FAILED":
            return t("The input token cannot be transferred. There may be an issue with the input token.");
        case "Pancake: TRANSFER_FAILED":
            return t("The output token cannot be transferred. There may be an issue with the output token.");
        default:
            if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("undefined is not an object")) !== -1) {
                console.error(error, reason);
                return t("An error occurred when trying to execute this swap. You may need to increase your slippage tolerance. If that does not work, there may be an incompatibility with the token you are trading.");
            }
            return t("Unknown error%reason%. Try increasing your slippage tolerance.", {
                reason: reason ? ': "'.concat(reason, '"') : ""
            });
    }
}

// EXTERNAL MODULE: ./src/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(97938);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
;// CONCATENATED MODULE: ./src/hooks/useWrapCallback.ts












var WrapType;
(function(WrapType) {
    WrapType[WrapType["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
    WrapType[WrapType["WRAP"] = 1] = "WRAP";
    WrapType[WrapType["UNWRAP"] = 2] = "UNWRAP";
})(WrapType || (WrapType = {}));
var NOT_APPLICABLE = {
    wrapType: WrapType.NOT_APPLICABLE
};
/**
 * Given the selected input and output currency, return a wrap callback
 * @param inputCurrency the selected input currency
 * @param outputCurrency the selected output currency
 * @param typedValue the user input value
 */ function useWrapCallback(inputCurrency, outputCurrency, typedValue) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var sattAddress = (0,hooks/* useSattWallet */.M)().sattAddress;
    var address = account || sattAddress || undefined;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var wbnbContract = (0,useContract/* useWBNBContract */.J8)();
    var balance = (0,wallet_hooks/* useCurrencyBalance */._h)(address !== null && address !== void 0 ? address : undefined, inputCurrency);
    // we can always parse the amount typed as the input currency, since wrapping is 1:1
    var inputAmount = (0,react.useMemo)(function() {
        return (0,tryParseAmount/* default */.Z)(typedValue, inputCurrency);
    }, [
        inputCurrency,
        typedValue
    ]);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    return (0,react.useMemo)(function() {
        if (!wbnbContract || !chainId || !inputCurrency || !outputCurrency) return NOT_APPLICABLE;
        var sufficientBalance = inputAmount && balance && !balance.lessThan(inputAmount);
        if (inputCurrency === sdk_esm/* ETHER */.c0 && (0,sdk_esm/* currencyEquals */.KA)(sdk_esm/* WETH */.DX[chainId], outputCurrency)) {
            return {
                wrapType: WrapType.WRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var txReceipt, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithGasPrice(wbnbContract, "deposit", undefined, {
                                        value: "0x".concat(inputAmount.raw.toString(16))
                                    })
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                addTransaction(txReceipt, {
                                    summary: "Wrap ".concat(inputAmount.toSignificant(6), " BNB to WBNB")
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not deposit", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient BNB balance")
            };
        }
        if ((0,sdk_esm/* currencyEquals */.KA)(sdk_esm/* WETH */.DX[chainId], inputCurrency) && outputCurrency === sdk_esm/* ETHER */.c0) {
            return {
                wrapType: WrapType.UNWRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var txReceipt, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithGasPrice(wbnbContract, "withdraw", [
                                        "0x".concat(inputAmount.raw.toString(16))
                                    ])
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                addTransaction(txReceipt, {
                                    summary: "Unwrap ".concat(inputAmount.toSignificant(6), " WBNB to BNB")
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not withdraw", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient WBNB balance")
            };
        }
        return NOT_APPLICABLE;
    }, [
        wbnbContract,
        chainId,
        inputCurrency,
        outputCurrency,
        t,
        inputAmount,
        balance,
        addTransaction,
        callWithGasPrice
    ]);
}

// EXTERNAL MODULE: ./src/state/swap/hooks.ts + 14 modules
var swap_hooks = __webpack_require__(47343);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(7010);
// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/SafemoonWarning.tsx



var SafemoonWarning = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    // Break translation sentences into pieces because the current translation approach doesn't support Link interpolation.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            children: [
                t("SAFEMOON has been migrated to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://bscscan.com/address/0x42981d0bfbAf196529376EE702F2a9Eb9092fcB5",
                    children: t("a new contract address.")
                }),
                " ",
                t("Trading on the old address may result in the complete loss of your assets. For more information please refer to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://twitter.com/safemoon/status/1477770592031887360",
                    children: [
                        t("Safemoon's announcement"),
                        "."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_SafemoonWarning = (SafemoonWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/ItamWarning.tsx



var ItamWarning = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            children: [
                t("ITAM has been rebranded as ITAM CUBE."),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://itam.network/swap",
                    children: t("Please proceed to ITAM bridge to conduct a one-way swap of your ITAM tokens.")
                }),
                " ",
                t("All transfers of the old ITAM token will be disabled after the swap.")
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_ItamWarning = (ItamWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/BondlyWarning.tsx



var BondlyWarning = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        children: t("Warning: BONDLY has been compromised. Please remove liquidity until further notice.")
    });
};
/* harmony default export */ var SwapWarningModal_BondlyWarning = (BondlyWarning);

// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/Acknowledgement.tsx




var Acknowledgement = function(param) {
    var handleContinueClick = param.handleContinueClick;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isConfirmed = ref[0], setIsConfirmed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            name: "confirmed",
                            type: "checkbox",
                            checked: isConfirmed,
                            onChange: function() {
                                return setIsConfirmed(!isConfirmed);
                            },
                            scale: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ml: "10px",
                            style: {
                                userSelect: "none"
                            },
                            children: t("I understand")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: !isConfirmed,
                    onClick: handleContinueClick,
                    children: t("Continue")
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_Acknowledgement = (Acknowledgement);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/CcarWarning.tsx



var CcarWarning = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            children: [
                t("Crypto Cars (CCAR) has been migrated to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://bscscan.com/token/0x322e5015Cc464Ada7f99dE7131CE494dE1834396",
                    children: t("a new contract address.")
                }),
                " ",
                t("Trading on the old address may result in the complete loss of your assets. For more information please refer to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://t.me/Crypto_Cars_Official/465037",
                    children: t("the announcement.")
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_CcarWarning = (CcarWarning);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/BTTWarning.tsx



var BTTWarning = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Please note that this is the old BTT token, which has been swapped to the new BTT tokens in the following ratio:")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: "1 BTT (OLD) = 1,000 BTT (NEW)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                mb: "8px",
                children: [
                    t("Trade the new BTT token"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        style: {
                            display: "inline"
                        },
                        href: "https://moon.biz/swap?outputCurrency=0x352Cb5E19b12FC216548a2677bD0fce83BaE434B",
                        children: t("here")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                href: "https://medium.com/@BitTorrent/tutorial-how-to-swap-bttold-to-btt-453264d7142",
                children: t("For more details on the swap, please refer here.")
            })
        ]
    });
};
/* harmony default export */ var SwapWarningModal_BTTWarning = (BTTWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/index.tsx


function SwapWarningModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 440px;\n"
    ]);
    SwapWarningModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwapWarningModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  justify-content: flex-start;\n"
    ]);
    SwapWarningModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var StyledModalContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-226846f8-0"
})(SwapWarningModal_templateObject());
var MessageContainer = (0,styled_components_browser_esm/* default */.ZP)(Message/* default */.Z).withConfig({
    componentId: "sc-226846f8-1"
})(SwapWarningModal_templateObject1());
// Modal is fired by a useEffect and doesn't respond to closeOnOverlayClick prop being set to false
var usePreventModalOverlayClick = function() {
    (0,react.useEffect)(function() {
        var preventClickHandler = function(e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        };
        document.querySelectorAll('[role="presentation"]').forEach(function(el) {
            el.addEventListener("click", preventClickHandler, true);
        });
        return function() {
            document.querySelectorAll('[role="presentation"]').forEach(function(el) {
                el.removeEventListener("click", preventClickHandler, true);
            });
        };
    }, []);
};
var SwapWarningModal = function(param) {
    var swapCurrency = param.swapCurrency, onDismiss = param.onDismiss;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.Z)().theme;
    usePreventModalOverlayClick();
    var _obj;
    var TOKEN_WARNINGS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, swapWarningTokens.safemoon.address, {
        symbol: swapWarningTokens.safemoon.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_SafemoonWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.bondly.address, {
        symbol: swapWarningTokens.bondly.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_BondlyWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.itam.address, {
        symbol: swapWarningTokens.itam.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_ItamWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.ccar.address, {
        symbol: swapWarningTokens.ccar.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_CcarWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.bttold.address, {
        symbol: swapWarningTokens.bttold.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_BTTWarning, {})
    }), _obj);
    var SWAP_WARNING = TOKEN_WARNINGS[swapCurrency.address];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContainer, {
        minWidth: "280px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalHeader */.xB, {
                background: theme.colors.gradients.cardHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    p: "12px 24px",
                    children: t("Notice for trading %symbol%", {
                        symbol: SWAP_WARNING.symbol
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageContainer, {
                        variant: "warning",
                        mb: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: SWAP_WARNING.component
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_Acknowledgement, {
                        handleContinueClick: onDismiss
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SwapWarningModal = (SwapWarningModal);

// EXTERNAL MODULE: ./src/views/Swap/components/Chart/PriceChartContainer.tsx + 6 modules
var PriceChartContainer = __webpack_require__(85187);
;// CONCATENATED MODULE: ./src/views/Swap/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  height: fit-content;\n  padding: 0 24px;\n\n  ",
        " {\n    padding: 0 40px;\n  }\n\n  ",
        " {\n    ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 328px;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwapContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f3994e2-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
}, function(param) {
    var $isChartExpanded = param.$isChartExpanded;
    return $isChartExpanded ? "padding: 0 120px" : "padding: 0 40px";
});
var StyledInputCurrencyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f3994e2-1"
})(styles_templateObject1());

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChartDisable.tsx
var ChartDisable = __webpack_require__(16883);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Chart.tsx
var Chart = __webpack_require__(85462);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(45341);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/History.tsx
var History = __webpack_require__(85714);
// EXTERNAL MODULE: ./src/components/App/Transactions/TransactionsModal.tsx + 1 modules
var TransactionsModal = __webpack_require__(86921);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/index.tsx + 4 modules
var GlobalSettings = __webpack_require__(8742);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./src/components/Svg/RefreshIcon.tsx





// NOTE: Temporary save icon here. Will move to uikit when the feature is done
var DisabledIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: "arrow_loading",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 1.5663V5.9898C9.00002 6.04324 9.01527 6.09557 9.04395 6.14066C9.07264 6.18575 9.11358 6.22174 9.16197 6.2444C9.21037 6.26707 9.26422 6.27547 9.31723 6.26864C9.37023 6.2618 9.42019 6.24 9.46125 6.2058L12.1163 3.99405C12.2513 3.88155 12.2513 3.67455 12.1163 3.56205L9.46125 1.3503C9.42019 1.3161 9.37023 1.2943 9.31723 1.28747C9.26422 1.28063 9.21037 1.28904 9.16197 1.3117C9.11358 1.33437 9.07264 1.37035 9.04395 1.41544C9.01527 1.46053 9.00002 1.51286 9 1.5663ZM5.62746 5.46444C6.60027 4.73532 7.78313 4.34099 8.99885 4.34052V3.21552C7.53993 3.21577 6.12036 3.68869 4.95277 4.56345C3.78519 5.4382 2.93244 6.6677 2.52227 8.06777C2.11209 9.46785 2.16657 10.9631 2.67755 12.3296C3.18852 13.6962 4.12848 14.8603 5.35663 15.6478C6.58478 16.4353 8.03501 16.8036 9.49008 16.6977C10.9451 16.5918 12.3267 16.0173 13.4279 15.0603C14.5291 14.1032 15.2905 12.8152 15.5982 11.3891C15.9059 9.96297 15.7432 8.47556 15.1346 7.14965C15.0687 7.02024 14.9553 6.92134 14.8181 6.87365C14.6809 6.82596 14.5306 6.83317 14.3986 6.89378C14.2666 6.9544 14.1632 7.06371 14.11 7.19884C14.0568 7.33397 14.0579 7.48444 14.1131 7.61877C14.6203 8.72364 14.7559 9.9631 14.4996 11.1515C14.2433 12.3399 13.6088 13.4133 12.6913 14.2108C11.7737 15.0084 10.6225 15.4872 9.41 15.5756C8.19749 15.664 6.98898 15.3572 5.96547 14.7011C4.94197 14.0451 4.15857 13.0751 3.7326 11.9364C3.30664 10.7977 3.26104 9.55173 3.60264 8.38499C3.94424 7.21824 4.65465 6.19357 5.62746 5.46444Z",
                fill: "#0B3D91"
            })
        })
    }));
};
var Icon = function(_param) {
    var disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "disabled"
    ]);
    return disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisabledIcon, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: "arrow_loading",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "none",
                fill: "#280D5F",
                d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "arrow",
                        stroke: "none",
                        fill: "none",
                        d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "arrow-clip",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#arrow"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#arrow-clip)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "5",
                    transform: "rotate(365,12,12)",
                    fill: "none",
                    stroke: "#7D9CD1",
                    strokeWidth: "16",
                    strokeDasharray: "30",
                    strokeDashoffset: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "stroke-dashoffset",
                        values: "0;-30",
                        begin: "arrow_loading.click; 0.7s",
                        repeatCount: "indefinite",
                        dur: "6.3s"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                xlinkHref: "#arrow"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_0",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "0 0 0",
                to: "-10 0 0",
                dur: "0.07s",
                begin: "arrow_loading.click;",
                repeatCount: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_1",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "-45 0 0",
                to: "390 0 0",
                dur: "0.6s",
                begin: "transform_0.end",
                repeatCount: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_2",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "390 0 0",
                to: "360 0 0",
                dur: "0.15s",
                begin: "transform_1.end",
                repeatCount: "1"
            })
        ]
    }));
};
/* harmony default export */ var RefreshIcon = (Icon);

;// CONCATENATED MODULE: ./src/components/Svg/RefreshIconWhite.tsx





// NOTE: Temporary save icon here. Will move to uikit when the feature is done
var RefreshIconWhite_DisabledIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: "arrow_loading",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 1.5663V5.9898C9.00002 6.04324 9.01527 6.09557 9.04395 6.14066C9.07264 6.18575 9.11358 6.22174 9.16197 6.2444C9.21037 6.26707 9.26422 6.27547 9.31723 6.26864C9.37023 6.2618 9.42019 6.24 9.46125 6.2058L12.1163 3.99405C12.2513 3.88155 12.2513 3.67455 12.1163 3.56205L9.46125 1.3503C9.42019 1.3161 9.37023 1.2943 9.31723 1.28747C9.26422 1.28063 9.21037 1.28904 9.16197 1.3117C9.11358 1.33437 9.07264 1.37035 9.04395 1.41544C9.01527 1.46053 9.00002 1.51286 9 1.5663ZM5.62746 5.46444C6.60027 4.73532 7.78313 4.34099 8.99885 4.34052V3.21552C7.53993 3.21577 6.12036 3.68869 4.95277 4.56345C3.78519 5.4382 2.93244 6.6677 2.52227 8.06777C2.11209 9.46785 2.16657 10.9631 2.67755 12.3296C3.18852 13.6962 4.12848 14.8603 5.35663 15.6478C6.58478 16.4353 8.03501 16.8036 9.49008 16.6977C10.9451 16.5918 12.3267 16.0173 13.4279 15.0603C14.5291 14.1032 15.2905 12.8152 15.5982 11.3891C15.9059 9.96297 15.7432 8.47556 15.1346 7.14965C15.0687 7.02024 14.9553 6.92134 14.8181 6.87365C14.6809 6.82596 14.5306 6.83317 14.3986 6.89378C14.2666 6.9544 14.1632 7.06371 14.11 7.19884C14.0568 7.33397 14.0579 7.48444 14.1131 7.61877C14.6203 8.72364 14.7559 9.9631 14.4996 11.1515C14.2433 12.3399 13.6088 13.4133 12.6913 14.2108C11.7737 15.0084 10.6225 15.4872 9.41 15.5756C8.19749 15.664 6.98898 15.3572 5.96547 14.7011C4.94197 14.0451 4.15857 13.0751 3.7326 11.9364C3.30664 10.7977 3.26104 9.55173 3.60264 8.38499C3.94424 7.21824 4.65465 6.19357 5.62746 5.46444Z",
                fill: "white"
            })
        })
    }));
};
var RefreshIconWhite_Icon = function(_param) {
    var disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "disabled"
    ]);
    return disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIconWhite_DisabledIcon, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: "arrow_loading",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "none",
                fill: "white",
                d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "arrow",
                        stroke: "none",
                        fill: "none",
                        d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "arrow-clip",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#arrow"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#arrow-clip)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "5",
                    transform: "rotate(365,12,12)",
                    fill: "none",
                    stroke: "#7D9CD1",
                    strokeWidth: "16",
                    strokeDasharray: "30",
                    strokeDashoffset: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "stroke-dashoffset",
                        values: "0;-30",
                        begin: "arrow_loading.click; 0.7s",
                        repeatCount: "indefinite",
                        dur: "6.3s"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                xlinkHref: "#arrow"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_0",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "0 0 0",
                to: "-10 0 0",
                dur: "0.07s",
                begin: "arrow_loading.click;",
                repeatCount: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_1",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "-45 0 0",
                to: "390 0 0",
                dur: "0.6s",
                begin: "transform_0.end",
                repeatCount: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_2",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "390 0 0",
                to: "360 0 0",
                dur: "0.15s",
                begin: "transform_1.end",
                repeatCount: "1"
            })
        ]
    }));
};
/* harmony default export */ var RefreshIconWhite = (RefreshIconWhite_Icon);

;// CONCATENATED MODULE: ./src/views/Swap/components/CurrencyInputHeader.tsx


function CurrencyInputHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    CurrencyInputHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencyInputHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    CurrencyInputHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var CurrencyInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-fbc0c972-0"
})(CurrencyInputHeader_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ColoredIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-fbc0c972-1"
})(CurrencyInputHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CurrencyInputHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, setIsChartDisplayed = param.setIsChartDisplayed, isChartDisplayed = param.isChartDisplayed, hasAmount = param.hasAmount, onRefreshPrice = param.onRefreshPrice;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useExpertModeManager */.DG)(), 1), expertMode = ref[0];
    var toggleChartDisplayed = function() {
        setIsChartDisplayed(function(currentIsChartDisplayed) {
            return !currentIsChartDisplayed;
        });
    };
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionsModal/* default */.Z, {})), 1), onPresentTransactionsModal = ref1[0];
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var swaptext = theme.isDark ? "white" : "#093174";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CurrencyInputContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    setIsChartDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredIconButton, {
                        onClick: toggleChartDisplayed,
                        variant: "text",
                        scale: "sm",
                        children: isChartDisplayed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartDisable/* default */.Z, {
                            color: "textSubtle"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                            width: "24px",
                            color: "textSubtle"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flexDirection: "column",
                        alignItems: "flex-end",
                        width: "100%",
                        mr: 18,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            color: swaptext,
                            as: "h2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                                show: expertMode,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings/* default */.Z, {
                                    color: "textSubtle",
                                    mr: "0"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: onPresentTransactionsModal,
                                variant: "text",
                                scale: "sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(History/* default */.Z, {
                                    color: "textSubtle",
                                    width: "24px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                variant: "text",
                                scale: "sm",
                                onClick: function() {
                                    return onRefreshPrice();
                                },
                                children: [
                                    !theme.isDark && /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIcon, {
                                        disabled: !hasAmount,
                                        width: "27px"
                                    }),
                                    theme.isDark && /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIconWhite, {
                                        disabled: !hasAmount,
                                        width: "27px"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "14px",
                    children: subtitle
                })
            })
        ]
    });
};
/* harmony default export */ var components_CurrencyInputHeader = (CurrencyInputHeader);

;// CONCATENATED MODULE: ./src/views/Swap/index.tsx




function Swap_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    Swap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Swap_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: inset 0px -2px 0px rgba(0, 0, 0, 0.1);\n\n  .icon-up-down {\n    display: none;\n  }\n  &:hover {\n    background-color: ",
        ";\n    .icon-down {\n      display: none;\n      fill: white;\n    }\n    .icon-up-down {\n      display: block;\n      fill: white;\n    }\n  }\n"
    ]);
    Swap_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













































var Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-844486f7-0"
})(Swap_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var SwitchIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-844486f7-1"
})(Swap_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
function Swap() {
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var loadedUrlParams = (0,swap_hooks/* useDefaultsFromURLSearch */.jj)();
    var t = (0,Localization/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref5 = (0,react.useState)(false), isChartExpanded = ref5[0], setIsChartExpanded = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useExchangeChartManager */.vD)(isMobile), 2), userChartPreference = ref6[0], setUserChartPreference = ref6[1];
    var ref7 = (0,react.useState)(userChartPreference), isChartDisplayed = ref7[0], setIsChartDisplayed = ref7[1];
    var ref8 = hooks_useRefreshBlockNumber(), refreshBlockNumber = ref8.refreshBlockNumber, isLoading = ref8.isLoading;
    (0,react.useEffect)(function() {
        setUserChartPreference(isChartDisplayed);
    }, [
        isChartDisplayed,
        setUserChartPreference
    ]);
    // token warning stuff
    var ref9 = [
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.inputCurrencyId),
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.outputCurrencyId), 
    ], loadedInputCurrency = ref9[0], loadedOutputCurrency = ref9[1];
    var ref10;
    var urlLoadedTokens = (0,react.useMemo)(function() {
        var ref;
        return (ref10 = (ref = [
            loadedInputCurrency,
            loadedOutputCurrency
        ]) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
            return (0,_instanceof/* default */.Z)(c, sdk_esm/* Token */.WU);
        })) !== null && ref10 !== void 0 ? ref10 : [];
    }, [
        loadedInputCurrency,
        loadedOutputCurrency
    ]);
    // dismiss warning if all imported tokens are in active lists
    var defaultTokens = (0,Tokens/* useAllTokens */.e_)();
    var importTokensNotInDefault = urlLoadedTokens && urlLoadedTokens.filter(function(token) {
        return !(token.address in defaultTokens);
    });
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var ref11 = (0,hooks/* useSattWallet */.M)(), sattAddress = ref11.sattAddress, isSattConnected = ref11.isSattConnected;
    // for expert mode
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useExpertModeManager */.DG)(), 1), isExpertMode = ref12[0];
    // get custom setting values for user
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref13[0];
    // swap state & price data
    var ref14 = (0,swap_hooks/* useSwapState */.dU)(), independentField = ref14.independentField, typedValue = ref14.typedValue, recipient = ref14.recipient, _INPUT = ref14[actions/* Field.INPUT */.gN.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref14[actions/* Field.OUTPUT */.gN.OUTPUT], outputCurrencyId = _OUTPUT.currencyId;
    var inputCurrency = (0,Tokens/* useCurrency */.U8)(inputCurrencyId);
    var outputCurrency = (0,Tokens/* useCurrency */.U8)(outputCurrencyId);
    var ref15 = (0,swap_hooks/* useDerivedSwapInfo */.SM)(independentField, typedValue, inputCurrency, outputCurrency, recipient), v2Trade = ref15.v2Trade, currencyBalances = ref15.currencyBalances, parsedAmount = ref15.parsedAmount, currencies = ref15.currencies, swapInputError = ref15.inputError, factoryType = ref15.factoryType;
    // getFactory()
    var ref16 = useWrapCallback(currencies[actions/* Field.INPUT */.gN.INPUT], currencies[actions/* Field.OUTPUT */.gN.OUTPUT], typedValue), wrapType = ref16.wrapType, onWrap = ref16.execute, wrapInputError = ref16.inputError;
    var showWrap = wrapType !== WrapType.NOT_APPLICABLE;
    var trade = showWrap ? undefined : v2Trade;
    var singleTokenPrice = (0,swap_hooks/* useSingleTokenSwapInfo */.yF)(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency);
    var _obj, _obj1;
    var parsedAmounts = showWrap ? (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, parsedAmount), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, parsedAmount), _obj) : (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, actions/* Field.INPUT */.gN.INPUT, independentField === actions/* Field.INPUT */.gN.INPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.inputAmount), (0,_define_property/* default */.Z)(_obj1, actions/* Field.OUTPUT */.gN.OUTPUT, independentField === actions/* Field.OUTPUT */.gN.OUTPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.outputAmount), _obj1);
    var ref17 = (0,swap_hooks/* useSwapActionHandlers */._r)(), onSwitchTokens = ref17.onSwitchTokens, onCurrencySelection = ref17.onCurrencySelection, onUserInput = ref17.onUserInput, onChangeRecipient = ref17.onChangeRecipient;
    var isValid = !swapInputError;
    var dependentField = independentField === actions/* Field.INPUT */.gN.INPUT ? actions/* Field.OUTPUT */.gN.OUTPUT : actions/* Field.INPUT */.gN.INPUT;
    var handleTypeInput = (0,react.useCallback)(function(value) {
        onUserInput(actions/* Field.INPUT */.gN.INPUT, value);
    }, [
        onUserInput
    ]);
    var handleTypeOutput = (0,react.useCallback)(function(value) {
        onUserInput(actions/* Field.OUTPUT */.gN.OUTPUT, value);
    }, [
        onUserInput
    ]);
    // modal and loading
    var ref18 = (0,react.useState)({
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    }), ref19 = ref18[0], tradeToConfirm = ref19.tradeToConfirm, swapErrorMessage = ref19.swapErrorMessage, attemptingTxn = ref19.attemptingTxn, txHash = ref19.txHash, setSwapState = ref18[1];
    var ref20, ref21;
    var _obj2;
    var formattedAmounts = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, independentField, typedValue), (0,_define_property/* default */.Z)(_obj2, dependentField, showWrap ? (ref20 = (ref = parsedAmounts[independentField]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref20 !== void 0 ? ref20 : "" : (ref21 = (ref1 = parsedAmounts[dependentField]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref21 !== void 0 ? ref21 : ""), _obj2);
    var route = trade === null || trade === void 0 ? void 0 : trade.route;
    var userHasSpecifiedInputOutput = Boolean(currencies[actions/* Field.INPUT */.gN.INPUT] && currencies[actions/* Field.OUTPUT */.gN.OUTPUT] && ((ref2 = parsedAmounts[independentField]) === null || ref2 === void 0 ? void 0 : ref2.greaterThan(sdk_esm/* JSBI.BigInt */.QA.BigInt(0))));
    var noRoute = !((route === null || route === void 0 ? void 0 : route.pairs[0].liquidityToken.address) !== "0x0000000000000000000000000000000000000000");
    // check whether the user has approved the router on the input token
    /* eslint-disable */ var ref22 = (0,_sliced_to_array/* default */.Z)(factoryType === "MoonBiz" ? (0,useApproveCallback/* useApproveCallbackFromTrade */.re)(trade, allowedSlippage) : (0,useApproveCallback/* useApproveCallbackFromTradePancake */.x)(trade, allowedSlippage), 2), approval = ref22[0], approveCallback = ref22[1];
    /* eslint-enable */ // check if user has gone through approval process, used to show two step buttons, reset on token change
    var ref23 = (0,react.useState)(false), approvalSubmitted = ref23[0], setApprovalSubmitted = ref23[1];
    // const handleTimer = () => {
    //   if (approval === ApprovalState.PENDING) {
    //     setApprovalSubmitted(false)
    //   }
    //   onSwitchTokens()
    // }
    // mark when a user has submitted an approval, reset onTokenSelection for input field
    (0,react.useEffect)(function() {
        // const timer = setTimeout(handleTimer, 2000)
        // return () => clearTimeout(timer)
        if (approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING) {
            setApprovalSubmitted(true);
        }
    }, [
        approval,
        approvalSubmitted
    ]);
    var maxAmountInput = (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[actions/* Field.INPUT */.gN.INPUT]);
    var atMaxAmountInput = Boolean(maxAmountInput && ((ref3 = parsedAmounts[actions/* Field.INPUT */.gN.INPUT]) === null || ref3 === void 0 ? void 0 : ref3.equalTo(maxAmountInput)));
    // the callback to execute the swap
    var ref24 = useSwapCallback(trade, allowedSlippage, recipient, factoryType), swapCallback = ref24.callback, swapCallbackError = ref24.error;
    var priceImpactWithoutFee = (0,prices/* computeTradePriceBreakdown */.U7)(trade).priceImpactWithoutFee;
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref25[0];
    var onPressHandleApprove = function() {
        if (isSattConnected) {
            return onPresentSattApproveModal();
        }
        return approveCallback();
    };
    // const handleShowSattPasswordModal = () => {
    //   setSwapState({
    //     attemptingTxn: false,
    //     tradeToConfirm,
    //     swapErrorMessage: undefined,
    //     txHash: undefined,
    //     ShowSattPasswordModal: true,
    //   })
    // }
    var handleSwap = (0,react.useCallback)(function(password) {
        if (priceImpactWithoutFee && !confirmPriceImpactWithoutFee(priceImpactWithoutFee, t)) {
            return;
        }
        if (!swapCallback) {
            return;
        }
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm: tradeToConfirm,
            swapErrorMessage: undefined,
            txHash: undefined
        });
        swapCallback(password).then(function(hash) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                swapErrorMessage: undefined,
                txHash: hash
            });
        }).catch(function(error) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                swapErrorMessage: error.message,
                txHash: undefined
            });
        });
    }, [
        priceImpactWithoutFee,
        swapCallback,
        tradeToConfirm,
        t
    ]);
    var onPressHandleSwap = function() {
        onPresentConfirmModal();
    };
    // errors
    var ref26 = (0,react.useState)(false), showInverted = ref26[0], setShowInverted = ref26[1];
    // warnings on slippage
    var priceImpactSeverity = (0,prices/* warningSeverity */.oX)(priceImpactWithoutFee);
    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    var showApproveFlow = !swapInputError && (approval === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING || approvalSubmitted && approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED) && !(priceImpactSeverity > 3 && !isExpertMode);
    var handleConfirmDismiss = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: tradeToConfirm,
            attemptingTxn: attemptingTxn,
            swapErrorMessage: swapErrorMessage,
            txHash: undefined
        });
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(actions/* Field.INPUT */.gN.INPUT, "");
        }
    }, [
        attemptingTxn,
        onUserInput,
        swapErrorMessage,
        tradeToConfirm,
        txHash
    ]);
    var handleAcceptChanges = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: trade,
            swapErrorMessage: swapErrorMessage,
            txHash: txHash,
            attemptingTxn: attemptingTxn
        });
    }, [
        attemptingTxn,
        swapErrorMessage,
        trade,
        txHash
    ]);
    // swap warning state
    var ref27 = (0,react.useState)(null), swapWarningCurrency = ref27[0], setSwapWarningCurrency = ref27[1];
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwapWarningModal, {
        swapCurrency: swapWarningCurrency
    })), 1), onPresentSwapWarningModal = ref28[0];
    (0,react.useEffect)(function() {
        if (swapWarningCurrency) {
            onPresentSwapWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        swapWarningCurrency
    ]);
    var handleInputSelect = (0,react.useCallback)(function(currencyInput) {
        setApprovalSubmitted(false) // reset 2 step UI for approvals
        ;
        onCurrencySelection(actions/* Field.INPUT */.gN.INPUT, currencyInput);
        var showSwapWarning = utils_shouldShowSwapWarning(currencyInput);
        if (showSwapWarning) {
            setSwapWarningCurrency(currencyInput);
        } else {
            setSwapWarningCurrency(null);
            onUserInput(actions/* Field.INPUT */.gN.INPUT, "");
        }
    }, [
        onCurrencySelection,
        onUserInput
    ]);
    var handleMaxInput = (0,react.useCallback)(function() {
        if (maxAmountInput) {
            onUserInput(actions/* Field.INPUT */.gN.INPUT, maxAmountInput.toExact());
        }
    }, [
        maxAmountInput,
        onUserInput
    ]);
    var handleOutputSelect = (0,react.useCallback)(function(currencyOutput) {
        onCurrencySelection(actions/* Field.OUTPUT */.gN.OUTPUT, currencyOutput);
        var showSwapWarning = utils_shouldShowSwapWarning(currencyOutput);
        if (showSwapWarning) {
            setSwapWarningCurrency(currencyOutput);
        } else {
            setSwapWarningCurrency(null);
        }
    }, [
        onCurrencySelection
    ]);
    var swapIsUnsupported = (0,Trades/* useIsTransactionUnsupported */.mP)(currencies === null || currencies === void 0 ? void 0 : currencies.INPUT, currencies === null || currencies === void 0 ? void 0 : currencies.OUTPUT);
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImportTokenWarningModal, {
        tokens: importTokensNotInDefault,
        onCancel: function() {
            return router.push("/swap");
        }
    })), 1), onPresentImportTokenWarningModal = ref29[0];
    (0,react.useEffect)(function() {
        if (importTokensNotInDefault.length > 0) {
            onPresentImportTokenWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        importTokensNotInDefault.length
    ]);
    var ref30 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmSwapModal, {
        trade: trade,
        originalTrade: tradeToConfirm,
        onAcceptChanges: handleAcceptChanges,
        attemptingTxn: attemptingTxn,
        txHash: txHash,
        recipient: recipient,
        allowedSlippage: allowedSlippage,
        onConfirm: handleSwap,
        swapErrorMessage: swapErrorMessage,
        customOnDismiss: handleConfirmDismiss
    }), true, true, "confirmSwapModal"), 1), onPresentConfirmModal = ref30[0];
    var ref31 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SattPasswordModal/* default */.Z, {
        confirmSattTransaction: approveCallback
    })), 1), onPresentSattApproveModal = ref31[0];
    var hasAmount = Boolean(parsedAmount);
    var onRefreshPrice = (0,react.useCallback)(function() {
        if (hasAmount) {
            refreshBlockNumber();
        }
    }, [
        hasAmount,
        refreshBlockNumber
    ]);
    var ref32;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        removePadding: isChartExpanded,
        hideFooterOnDesktop: isChartExpanded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            width: "100%",
            justifyContent: "center",
            position: "relative",
            children: [
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceChartContainer/* default */.Z, {
                    inputCurrencyId: inputCurrencyId,
                    inputCurrency: currencies[actions/* Field.INPUT */.gN.INPUT],
                    outputCurrencyId: outputCurrencyId,
                    outputCurrency: currencies[actions/* Field.OUTPUT */.gN.OUTPUT],
                    isChartExpanded: isChartExpanded,
                    setIsChartExpanded: setIsChartExpanded,
                    isChartDisplayed: isChartDisplayed,
                    currentSwapPrice: singleTokenPrice
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomDrawer/* default */.Z, {
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceChartContainer/* default */.Z, {
                        inputCurrencyId: inputCurrencyId,
                        inputCurrency: currencies[actions/* Field.INPUT */.gN.INPUT],
                        outputCurrencyId: outputCurrencyId,
                        outputCurrency: currencies[actions/* Field.OUTPUT */.gN.OUTPUT],
                        isChartExpanded: isChartExpanded,
                        setIsChartExpanded: setIsChartExpanded,
                        isChartDisplayed: isChartDisplayed,
                        currentSwapPrice: singleTokenPrice,
                        isMobile: true
                    }),
                    isOpen: isChartDisplayed,
                    setIsOpen: setIsChartDisplayed
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwapContainer, {
                            $isChartExpanded: isChartExpanded,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInputCurrencyWrapper, {
                                mt: isChartExpanded ? "24px" : "0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(App/* AppBody */.j, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CurrencyInputHeader, {
                                                title: t("Swap"),
                                                subtitle: t("Trade tokens in an instant"),
                                                setIsChartDisplayed: setIsChartDisplayed,
                                                hasAmount: hasAmount,
                                                onRefreshPrice: onRefreshPrice
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                                                id: "swap-page",
                                                style: {
                                                    minHeight: "412px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                                        gap: "sm",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                                                label: independentField === actions/* Field.OUTPUT */.gN.OUTPUT && !showWrap && trade ? t("From (estimated)") : t("From"),
                                                                value: formattedAmounts[actions/* Field.INPUT */.gN.INPUT],
                                                                showMaxButton: !atMaxAmountInput,
                                                                currency: currencies[actions/* Field.INPUT */.gN.INPUT],
                                                                onUserInput: handleTypeInput,
                                                                onMax: handleMaxInput,
                                                                onCurrencySelect: handleInputSelect,
                                                                otherCurrency: currencies[actions/* Field.OUTPUT */.gN.OUTPUT],
                                                                id: "swap-currency-input"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                                                                justify: "space-between",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* AutoRow */.BA, {
                                                                    justify: isExpertMode ? "space-between" : "center",
                                                                    style: {
                                                                        padding: "0 1rem"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchIconButton, {
                                                                        variant: "light",
                                                                        scale: "sm",
                                                                        onClick: function() {
                                                                            setApprovalSubmitted(false) // reset 2 step UI for approvals
                                                                            ;
                                                                            onSwitchTokens();
                                                                            onUserInput(actions/* Field.INPUT */.gN.INPUT, "");
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                                                                className: "icon-down",
                                                                                color: currencies[actions/* Field.INPUT */.gN.INPUT] && currencies[actions/* Field.OUTPUT */.gN.OUTPUT] ? "primary" : "text"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpDown/* default */.Z, {
                                                                                className: "icon-up-down",
                                                                                color: currencies[actions/* Field.INPUT */.gN.INPUT] && currencies[actions/* Field.OUTPUT */.gN.OUTPUT] ? "primary" : "text"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                                                value: formattedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT],
                                                                onUserInput: handleTypeOutput,
                                                                label: independentField === actions/* Field.INPUT */.gN.INPUT && !showWrap && trade ? t("To (estimated)") : t("To"),
                                                                showMaxButton: false,
                                                                currency: currencies[actions/* Field.OUTPUT */.gN.OUTPUT],
                                                                onCurrencySelect: handleOutputSelect,
                                                                otherCurrency: currencies[actions/* Field.INPUT */.gN.INPUT],
                                                                id: "swap-currency-output"
                                                            }),
                                                            isExpertMode && recipient !== null && !showWrap ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                                                        justify: "space-between",
                                                                        style: {
                                                                            padding: "0 1rem"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                                                                                clickable: false,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                                                                    width: "16px"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                variant: "text",
                                                                                id: "remove-recipient-button",
                                                                                onClick: function() {
                                                                                    return onChangeRecipient(null);
                                                                                },
                                                                                children: t("- Remove send")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputPanel, {
                                                                        id: "recipient",
                                                                        value: recipient,
                                                                        onChange: onChangeRecipient
                                                                    })
                                                                ]
                                                            }) : null,
                                                            showWrap ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                                                gap: "7px",
                                                                style: {
                                                                    padding: "0 16px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                                                                        align: "center",
                                                                        children: Boolean(trade) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                                                    children: t("Price")
                                                                                }),
                                                                                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                                    width: "100%",
                                                                                    ml: "8px",
                                                                                    height: "24px"
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TradePrice, {
                                                                                    price: trade === null || trade === void 0 ? void 0 : trade.executionPrice,
                                                                                    showInverted: showInverted,
                                                                                    setShowInverted: setShowInverted
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                                        align: "center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                                                children: t("Slippage Tolerance")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                                bold: true,
                                                                                color: "#7D9CD1",
                                                                                children: [
                                                                                    allowedSlippage / 100,
                                                                                    "%"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        mt: "0.25rem",
                                                        children: [
                                                            swapIsUnsupported ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                width: "100%",
                                                                disabled: true,
                                                                children: t("Unsupported Asset")
                                                            }) : !account && !sattAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                                                width: "100%"
                                                            }) : showWrap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                width: "100%",
                                                                disabled: Boolean(wrapInputError),
                                                                onClick: onWrap,
                                                                children: wrapInputError !== null && wrapInputError !== void 0 ? wrapInputError : wrapType === WrapType.WRAP ? "Wrap" : wrapType === WrapType.UNWRAP ? "Unwrap" : null
                                                            }) : noRoute && userHasSpecifiedInputOutput ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* GreyCard */.h2, {
                                                                style: {
                                                                    textAlign: "center",
                                                                    padding: "0.75rem"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                        color: "textSubtle",
                                                                        children: t("Insufficient liquidity for this trade.")
                                                                    }),
                                                                    singleHopOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                        color: "textSubtle",
                                                                        children: t("Try enabling multi-hop trades.")
                                                                    })
                                                                ]
                                                            }) : showApproveFlow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        variant: approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED ? "success" : "primary",
                                                                        onClick: onPressHandleApprove,
                                                                        disabled: approval !== useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalSubmitted,
                                                                        width: "48%",
                                                                        children: approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                                                            gap: "6px",
                                                                            justify: "center",
                                                                            children: [
                                                                                t("Enabling"),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {
                                                                                    stroke: "white"
                                                                                })
                                                                            ]
                                                                        }) : approvalSubmitted && approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED ? t("Enabled") : t("Enable %asset%", {
                                                                            asset: (ref32 = (ref4 = currencies[actions/* Field.INPUT */.gN.INPUT]) === null || ref4 === void 0 ? void 0 : ref4.symbol) !== null && ref32 !== void 0 ? ref32 : ""
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        variant: isValid && priceImpactSeverity > 2 ? "danger" : "primary",
                                                                        onClick: function() {
                                                                            if (isExpertMode) {
                                                                                handleSwap();
                                                                            } else {
                                                                                setSwapState({
                                                                                    tradeToConfirm: trade,
                                                                                    attemptingTxn: false,
                                                                                    swapErrorMessage: undefined,
                                                                                    txHash: undefined
                                                                                });
                                                                                onPresentConfirmModal();
                                                                            }
                                                                        },
                                                                        width: "48%",
                                                                        id: "swap-button",
                                                                        disabled: !isValid || approval !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || priceImpactSeverity > 3 && !isExpertMode,
                                                                        children: priceImpactSeverity > 3 && !isExpertMode ? t("Price Impact High") : priceImpactSeverity > 2 ? t("Swap Anyway") : t("Swap")
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: isValid && priceImpactSeverity > 2 && !swapCallbackError ? "danger" : "primary",
                                                                onClick: function() {
                                                                    if (isExpertMode) {
                                                                        handleSwap();
                                                                    } else {
                                                                        setSwapState({
                                                                            tradeToConfirm: trade,
                                                                            attemptingTxn: false,
                                                                            swapErrorMessage: undefined,
                                                                            txHash: undefined
                                                                        });
                                                                        onPressHandleSwap();
                                                                    }
                                                                },
                                                                id: "swap-button",
                                                                width: "100%",
                                                                disabled: !isValid || priceImpactSeverity > 3 && !isExpertMode || !!swapCallbackError,
                                                                children: swapInputError || (priceImpactSeverity > 3 && !isExpertMode ? t("Price Impact Too High") : priceImpactSeverity > 2 ? t("Swap Anyway") : t("Swap"))
                                                            }),
                                                            showApproveFlow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.ZP, {
                                                                style: {
                                                                    marginTop: "1rem"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressCircles, {
                                                                    steps: [
                                                                        approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED
                                                                    ]
                                                                })
                                                            }),
                                                            isExpertMode && swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                                                                error: swapErrorMessage
                                                            }) : null
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !swapIsUnsupported ? trade && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSwapDetailsDropdown, {
                                        trade: trade
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsupportedCurrencyFooter/* default */.Z, {
                                        currencies: [
                                            currencies.INPUT,
                                            currencies.OUTPUT
                                        ]
                                    })
                                ]
                            })
                        }),
                        isChartExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: [
                                "none",
                                null,
                                null,
                                "block"
                            ],
                            width: "100%",
                            height: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                                variant: "side",
                                helpUrl: constants/* EXCHANGE_DOCS_URLS */.SO
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ })

}]);